// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FooterNaed: React.FC<{ width?: number; height?: number }> = ({ width = 41, height = 24 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M30.998 11.664v.574c0 .462-.214.748-.804.748h-2.163v-2.005h2.163c.557 0 .804.115.804.683m-13.222-.774-.727 1.563h1.48zm0 0-.727 1.563h1.48zm0 0-.727 1.563h1.48zm12.26 3.31H26.69V9.82h3.131c1.919 0 2.4.456 2.4 1.7v.919c0 1.198-.223 1.763-2.184 1.763m-9.535 6.79L9.979 14.83H31.02zM8.71 14.2V9.82h2.127l2.13 3.179-.002-3.179h1.302v4.382h-2.162L9.944 10.93l.004 3.27zm12.152 0h-1.514l-.31-.732h-2.56l-.292.733h-1.518l2.262-4.382h1.731zm4.778-2.76v1.043h-3.06v.572h3.26V14.2H21.37V9.819h4.465v1.085H22.58v.537zM20.5 2.99l10.52 6.161H9.98zm0-2.99L0 12.001 20.501 24 41 12.001zm-2.725 10.89-.727 1.563h1.48zm0 0-.727 1.563h1.48zm0 0-.727 1.563h1.48zm0 0-.727 1.563h1.48z"
            />
        </svg>
    );
};

export default React.memo(FooterNaed);
